const React = require('react');
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';


 export class RadioButtonModal extends React.Component{
   constructor(props) {
      super(props);
      this.state={
         buttonText: (this.props.radioButtons) ? this.props.radioButtons[0] : ''
      }
   }

   confirm(){
      this.props.confirmFunction(this.state.buttonText);
      this.props.closeFunction();
   }

   componentDidUpdate(prevProps){
      if(prevProps.defaultValue !== this.props.defaultValue){
         this.setState({buttonText: this.props.defaultValue});
      }
   }

   render() {
      return (
         <Dialog
            open={this.props.show}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
         >
            <DialogContent>
               <DialogContentText>
                  {this.props.contentText}
               </DialogContentText>
               <RadioGroup
                  aria-label="radio-dialog-title"
                  name="radioButtonType"
                  value={this.state.buttonText}
                  onChange={() => this.setState({ buttonText: event.target.value })}
                  
               >
                  {
                     this.props.radioButtons.map(function (data, index) {
                        return <FormControlLabel
                           value={data}
                           control={<Radio color={'primary'} />}
                           label={data}
                           key={index}
                        />;
                     })
                  }
               </RadioGroup>
            </DialogContent>
            <DialogActions>
               <Button onClick={() => this.props.closeFunction()} className={'btnRadioButtonModalCancel'} color="primary">
                  Cancel
               </Button>
               <Button onClick={() => this.confirm()} className={'btnRadioButtonModalConfirm'} color="primary" autoFocus>
                  {this.props.confirmText}
               </Button>
            </DialogActions>
         </Dialog>
      )
   }
}

